export const timeout = (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export const logger = (...data) => {
	if (process.env.NODE_ENV == 'development') {
		return console.log(...data);
	}
}
